var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEligibilityError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 128,
    viewBox: "0 0 134 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Action=Launch app, Type=Greyscale"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M70.9661 101.606C98.9661 101.606 121.666 78.9059 121.666 50.8059C121.666 22.7059 98.8661 0.00585938 70.9661 0.00585938C42.9661 0.00585938 20.2661 22.7059 20.2661 50.8059C20.2661 78.9059 42.9661 101.606 70.9661 101.606Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M124.815 83.5857C127.08 83.5857 128.915 81.7457 128.915 79.4857C128.915 77.2157 127.08 75.3857 124.815 75.3857C122.551 75.3857 120.715 77.2157 120.715 79.4857C120.715 81.7457 122.551 83.5857 124.815 83.5857Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M130.816 67.5863C132.362 67.5863 133.616 66.3263 133.616 64.7863C133.616 63.2363 132.362 61.9863 130.816 61.9863C129.269 61.9863 128.016 63.2363 128.016 64.7863C128.016 66.3263 129.269 67.5863 130.816 67.5863Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M22.965 17.4057C24.512 17.4057 25.765 16.1557 25.765 14.6057C25.765 13.0557 24.512 11.8057 22.965 11.8057C21.419 11.8057 20.165 13.0557 20.165 14.6057C20.165 16.1557 21.419 17.4057 22.965 17.4057Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M5.86504 71.4059C8.73704 71.4059 11.065 69.0759 11.065 66.2059C11.065 63.3359 8.73704 61.0059 5.86504 61.0059C2.99404 61.0059 0.665039 63.3359 0.665039 66.2059C0.665039 69.0759 2.99404 71.4059 5.86504 71.4059Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M108.777 52.0061L111.48 51.1861C111.676 51.1361 111.676 50.8461 111.48 50.7961L108.777 49.9761C108.708 49.9561 108.657 49.9061 108.638 49.8361L107.824 47.1461C107.767 46.9461 107.483 46.9461 107.426 47.1461L106.612 49.8361C106.593 49.9061 106.542 49.9561 106.473 49.9761L103.777 50.7961C103.581 50.8461 103.581 51.1361 103.777 51.1861L106.479 52.0061C106.548 52.0261 106.599 52.0761 106.618 52.1461L107.432 54.8461C107.489 55.0461 107.773 55.0461 107.83 54.8461L108.645 52.1461C108.657 52.0761 108.708 52.0261 108.777 52.0061Z",
    fill: "#ADB6C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M92.7769 23.0061L95.4799 22.1861C95.6759 22.1361 95.6759 21.8461 95.4799 21.7961L92.7769 20.9761C92.7079 20.9561 92.6569 20.9061 92.6379 20.8361L91.8239 18.1461C91.7669 17.9461 91.4829 17.9461 91.4259 18.1461L90.6119 20.8361C90.5929 20.9061 90.5419 20.9561 90.4729 20.9761L87.7769 21.7961C87.5809 21.8461 87.5809 22.1361 87.7769 22.1861L90.4789 23.0061C90.5479 23.0261 90.5989 23.0761 90.6179 23.1461L91.4319 25.8461C91.4889 26.0461 91.7729 26.0461 91.8299 25.8461L92.6449 23.1461C92.6569 23.0761 92.7079 23.0261 92.7769 23.0061Z",
    fill: "#ADB6C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M52.1341 26.3755L54.4991 25.6655C54.6701 25.6155 54.6701 25.3655 54.4991 25.3155L52.1341 24.6055C52.0731 24.5855 52.0291 24.5455 52.0121 24.4855L51.3001 22.1255C51.2501 21.9555 51.0011 21.9555 50.9521 22.1255L50.2391 24.4855C50.2221 24.5455 50.1781 24.5855 50.1171 24.6055L47.7581 25.3155C47.5871 25.3655 47.5871 25.6155 47.7581 25.6655L50.1231 26.3755C50.1841 26.3955 50.2281 26.4355 50.2441 26.4955L50.9571 28.8655C51.0071 29.0355 51.2551 29.0355 51.3051 28.8655L52.0181 26.4955C52.0291 26.4355 52.0731 26.3955 52.1341 26.3755Z",
    fill: "#ADB6C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M35.1341 69.8059L37.4991 68.9959C37.6701 68.9359 37.6701 68.6559 37.4991 68.5959L35.1341 67.7759C35.0731 67.7659 35.0291 67.7059 35.0121 67.6459L34.3001 64.9459C34.2501 64.7459 34.0011 64.7459 33.9521 64.9459L33.2391 67.6459C33.2221 67.7059 33.1781 67.7659 33.1171 67.7759L30.7581 68.5959C30.5871 68.6559 30.5871 68.9359 30.7581 68.9959L33.1231 69.8059C33.1841 69.8259 33.2281 69.8759 33.2441 69.9459L33.9571 72.6459C34.0071 72.8459 34.2551 72.8459 34.3051 72.6459L35.0181 69.9459C35.0291 69.8759 35.0731 69.8259 35.1341 69.8059Z",
    fill: "#ADB6C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    d: "M31.3481 39.0054L33.0371 38.4954C33.1591 38.4654 33.1591 38.2854 33.0371 38.2554L31.3481 37.7454C31.3051 37.7354 31.2731 37.6954 31.2611 37.6554L30.7521 35.9754C30.7171 35.8454 30.5391 35.8454 30.5041 35.9754L29.9941 37.6554C29.9831 37.6954 29.9511 37.7354 29.9081 37.7454L28.2231 38.2554C28.1001 38.2854 28.1001 38.4654 28.2231 38.4954L29.9121 39.0054C29.9551 39.0254 29.9871 39.0554 29.9981 39.0954L30.5071 40.7854C30.5431 40.9054 30.7211 40.9054 30.7561 40.7854L31.2651 39.0954C31.2731 39.0554 31.3051 39.0254 31.3481 39.0054Z",
    fill: "#ADB6C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    d: "M49.3479 55.7159L51.0369 55.2059C51.1589 55.1759 51.1589 54.9959 51.0369 54.9559L49.3479 54.4459C49.3039 54.4359 49.2729 54.4059 49.2609 54.3659L48.7519 52.6759C48.7159 52.5559 48.5389 52.5559 48.5029 52.6759L47.9939 54.3659C47.9819 54.4059 47.9509 54.4359 47.9069 54.4459L46.2219 54.9559C46.0999 54.9959 46.0999 55.1759 46.2219 55.2059L47.9109 55.7159C47.9539 55.7259 47.9859 55.7559 47.9979 55.8059L48.5069 57.4959C48.5419 57.6159 48.7199 57.6159 48.7559 57.4959L49.2649 55.8059C49.2729 55.7559 49.3039 55.7259 49.3479 55.7159Z",
    fill: "#ADB6C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    d: "M63.6689 8.12609L65.3579 7.61609C65.4809 7.57609 65.4809 7.40609 65.3579 7.36609L63.6689 6.85609C63.6259 6.84609 63.5939 6.81609 63.5819 6.77609L63.0729 5.08609C63.0379 4.96609 62.8599 4.96609 62.8249 5.08609L62.3159 6.77609C62.3039 6.81609 62.2719 6.84609 62.2289 6.85609L60.5439 7.36609C60.4209 7.40609 60.4209 7.57609 60.5439 7.61609L62.2329 8.12609C62.2759 8.13609 62.3079 8.16609 62.3199 8.21609L62.8289 9.89609C62.8639 10.0261 63.0419 10.0261 63.0769 9.89609L63.5859 8.21609C63.5939 8.16609 63.6259 8.13609 63.6689 8.12609Z",
    fill: "#ADB6C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    d: "M103.692 80.4757L105.381 79.9657C105.504 79.9257 105.504 79.7557 105.381 79.7157L103.692 79.2057C103.649 79.1957 103.617 79.1657 103.605 79.1257L103.096 77.4357C103.061 77.3157 102.883 77.3157 102.848 77.4357L102.339 79.1257C102.327 79.1657 102.295 79.1957 102.252 79.2057L100.567 79.7157C100.444 79.7557 100.444 79.9257 100.567 79.9657L102.256 80.4757C102.299 80.4857 102.331 80.5157 102.343 80.5657L102.852 82.2557C102.887 82.3757 103.065 82.3757 103.1 82.2557L103.609 80.5657C103.617 80.5157 103.649 80.4857 103.692 80.4757Z",
    fill: "#ADB6C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    d: "M56.031 58.5557C51.778 61.6557 46.189 66.1457 46.189 70.0957C46.189 72.4157 46.189 75.7057 46.189 78.0357C46.189 78.9757 47.538 79.5457 48.316 79.0157C50.368 77.6157 53.915 76.0157 59.008 76.4757C67.635 77.2657 57.489 62.8057 57.489 62.8057L56.031 58.5557Z",
    fill: "url(#paint0_linear_1227_12691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M86.954 58.5557C91.207 61.7157 96.796 66.1457 96.796 70.0957C96.796 72.4157 96.796 75.7057 96.796 78.0357C96.796 78.9757 95.447 79.5457 94.669 79.0157C92.617 77.6157 89.07 76.0157 83.977 76.4757C75.35 77.2657 85.496 62.8057 85.496 62.8057L86.954 58.5557Z",
    fill: "url(#paint1_linear_1227_12691)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_16",
    filter: "url(#filter0_d_1227_12691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.462 15.0557C63.443 20.7657 53.844 34.7957 55.606 52.6657C57.307 70.5257 58.826 79.3357 62.106 81.4557C65.448 83.5857 68.728 84.0757 71.462 84.0757C74.196 84.0757 77.477 83.5857 80.818 81.4557C84.16 79.3357 85.618 70.5257 87.319 52.6657C89.02 34.7957 79.421 20.7657 71.462 15.0557Z",
    fill: "url(#paint2_linear_1227_12691)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    d: "M77.537 86.5657H65.387C64.415 86.5657 63.686 85.7757 63.686 84.8657V81.8857H79.299V84.7957C79.239 85.7757 78.449 86.5657 77.537 86.5657Z",
    fill: "url(#paint3_linear_1227_12691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M72.3128 57.5859H70.6118V80.0059H72.3128V57.5859Z",
    fill: "url(#paint4_linear_1227_12691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.4622 45.3757C74.7842 45.3757 77.4772 42.6757 77.4772 39.3557C77.4772 36.0357 74.7842 33.3457 71.4622 33.3457C68.1402 33.3457 65.4482 36.0357 65.4482 39.3557C65.4482 42.6757 68.1402 45.3757 71.4622 45.3757Z",
    stroke: "#9FA8BA",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M79.7849 98.1659C79.7849 103.086 75.8369 127.756 70.9159 127.756C65.9949 127.756 62.0459 103.086 62.0459 98.1659C62.0459 93.2459 65.9949 89.2959 70.9159 89.2959C75.8369 89.2959 79.7849 93.3059 79.7849 98.1659Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    d: "M70.9159 116.395C69.1539 112.625 67.1489 102.175 67.1489 98.8354C67.1489 96.7654 68.8499 95.0654 70.9159 95.0654C72.9809 95.0654 74.6819 96.7654 74.6819 98.8354C74.6819 102.175 72.6769 112.565 70.9159 116.395Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1227_12691",
    x: 33.3945,
    y: 4.05566,
    width: 76.1226,
    height: 113.02,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.396078 0 0 0 0 0.478431 0 0 0 0 0.576471 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1227_12691"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1227_12691",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1227_12691",
    x1: 49.4012,
    y1: 59.3257,
    x2: 49.4012,
    y2: 71.8457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1227_12691",
    x1: 83.7132,
    y1: 59.3257,
    x2: 83.7132,
    y2: 71.8457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1227_12691",
    x1: 54.8395,
    y1: 13.4568,
    x2: 54.8395,
    y2: 84.8183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1227_12691",
    x1: 63.4136,
    y1: 81.7757,
    x2: 63.4136,
    y2: 86.6157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1227_12691",
    x1: 70.9846,
    y1: 58.3659,
    x2: 70.9846,
    y2: 70.9459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEligibilityError);
export default __webpack_public_path__ + "static/media/eligibility-error.4af5504748da9c813d6fa87f53bf2002.svg";
export { ForwardRef as ReactComponent };